import { Loader2 } from "lucide-react";

/**
 * Fallback de carregamento para o <Suspense> das rotas lazy.
 *
 * ESTUDO DE LAYOUT SHIFT (CLS / flicker):
 * - Este fallback é renderizado DENTRO da área de conteúdo do layout (o
 *   cabeçalho e os menus permanecem montados), então a "casca" nunca pisca.
 * - Reservamos altura mínima (min-h) e repetimos a estrutura típica das
 *   páginas (título + grade de cards) para que a troca do esqueleto pelo
 *   conteúdo real NÃO empurre a página verticalmente (evita o "pulo").
 * - Usamos apenas opacidade/animação de pulse (sem mudar dimensões).
 */
export function ContentFallback() {
  return (
    <div data-testid="route-fallback" className="animate-pulse min-h-[60vh]">
      {/* Linha do título */}
      <div className="h-9 w-56 rounded-lg bg-white/10 mb-2" />
      <div className="h-4 w-80 rounded bg-white/5 mb-8" />

      {/* Grade de cards (mesma silhueta do dashboard/listas) */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="h-28 rounded-xl bg-white/[0.06] border border-white/10" />
        ))}
      </div>

      {/* Blocos de seção */}
      <div className="space-y-4">
        <div className="h-24 rounded-xl bg-white/[0.04] border border-white/10" />
        <div className="h-24 rounded-xl bg-white/[0.04] border border-white/10" />
      </div>
    </div>
  );
}

/** Fallback de tela cheia — usado nas rotas SEM layout (login, totem, SSO...). */
export function FullScreenFallback() {
  return (
    <div
      data-testid="route-fallback-fullscreen"
      className="min-h-screen w-full flex items-center justify-center bg-brand-dark"
    >
      <Loader2 className="w-8 h-8 text-brand-light animate-spin" />
    </div>
  );
}

export default ContentFallback;
